'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp, _initialiseProps;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactDom = require('react-dom');

var _util = require('../util');

var _util2 = _interopRequireDefault(_util);

var _lodashCompat = require('lodash-compat');

var _lodashCompat2 = _interopRequireDefault(_lodashCompat);

var _scrollIntoViewIfNeeded = require('../util/shim/scrollIntoViewIfNeeded');

var _scrollIntoViewIfNeeded2 = _interopRequireDefault(_scrollIntoViewIfNeeded);

var _checkbox = require('../checkbox');

var _trigger = require('../trigger');

var _trigger2 = _interopRequireDefault(_trigger);

var _data = require('../util/data');

var _util3 = require('./util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
  var resolver = this;

  if (catcher === true) {
    if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
      var _tasks = [];

      if (!tick) {
        try {
          tick = process.nextTick;
        } catch (ex) {
          tick = function tick(p) {
            setTimeout(p, 0);
          };
        }
      }

      function _untask() {
        for (var i = 0; i < _tasks.length; i += 2) {
          var t = _tasks[i + 1],
              r = _tasks[i];

          for (var j = 0; j < t.length; j++) {
            t[j].call(null, r);
          }
        }

        _tasks = [];
      }

      function isThenable(obj) {
        return obj && obj instanceof Object && typeof obj.then === 'function';
      }

      function EagerThenable(resolver) {
        function done(inline) {
          var w;
          if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

          _tasks.push(result, w);

          _thens = [[], []];
          if (_tasks.length === 2) inline ? _untask() : tick(_untask);
        }

        function resolveThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 0;
          result = x;
          done(true);
        }

        function rejectThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 1;
          result = x;
          done(true);
        }

        function settler(resolver, rejecter) {
          _thens[0].push(resolver);

          _thens[1].push(rejecter);

          done();
        }

        function toString() {
          return 'EagerThenable{' + {
            '-1': 'pending',
            0: 'resolved',
            1: 'rejected'
          }[phase] + '}=' + result.toString();
        }

        this.then = settler;
        this.toString = toString;
        var _thens = [[], []],
            _sync = true,
            phase = -1,
            result;
        resolver.call(null, resolveThen, rejectThen);
        _sync = false;
        done();
      }

      EagerThenable.resolve = function (v) {
        return isThenable(v) ? v : {
          then: function then(resolve, reject) {
            return resolve(v);
          }
        };
      };

      return EagerThenable;
    }();
    return new Function.prototype.$asyncbind.EagerThenable(boundThen);
  }

  if (catcher) {
    if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
    return then;
  }

  function then(result, error) {
    try {
      return result && result instanceof Object && typeof result.then === 'function' ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
    } catch (ex) {
      return (error || catcher)(ex);
    }
  }

  function boundThen(result, error) {
    return resolver.call(self, result, error);
  }

  boundThen.then = boundThen;
  return boundThen;
};

var valueObjectShape = void 0;
var modelObjectShape = void 0;

if (_propTypes2.default) {
  valueObjectShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    value: _propTypes2.default.oneOfType[(_propTypes2.default.string, _propTypes2.default.number)],
    label: _propTypes2.default.oneOfType[(_propTypes2.default.string, _propTypes2.default.number)]
  })]);
  modelObjectShape = _propTypes2.default.shape({
    idField: _propTypes2.default.string,
    showField: _propTypes2.default.string,
    tpl: _propTypes2.default.string,
    showTpl: _propTypes2.default.string,
    format: _propTypes2.default.function, // TODO 搜索图标
    height: _propTypes2.default.oneOfType[(_propTypes2.default.number, _propTypes2.default.string)],
    disabledField: _propTypes2.default.string
  });
}

var Select = (_temp = _class = function (_M$BaseComponent) {
  _inherits(Select, _M$BaseComponent);

  function Select(props) {
    _classCallCheck(this, Select);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Select).call(this, props));

    _initialiseProps.call(_this);

    var _ref = props.model || {};

    var idField = _ref.idField;
    var showField = _ref.showField;

    if ((idField === "label" || showField === "value") && idField !== showField) {
      console.error("Select 中使用了 value 与 label, 请使用其他的属性作为 idField 和 showField");
    }
    if (props.fetchDataAction) {
      console.warn("Select 组件接收属性 fetchDataAction 请替换成 onFetchData");
    }
    _this.warned = false;
    _this.state = {
      value: (0, _util3.getRenderValue)(props.value, props, props.checkValueConstructor),
      searchword: '',
      data: [],
      showData: null,
      allSelect: false,
      visible: false,
      valid: true,
      fetchErrorMessage: ''
    };
    return _this;
  }

  _createClass(Select, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props;
      var defaultValue = _props.defaultValue;
      var checkValueConstructor = _props.checkValueConstructor;

      if (defaultValue && !this.state.value) {
        // 只在这个时候来初始值
        checkValueConstructor && (this.warned = true);
        this.setState({ value: (0, _util3.getRenderValue)(defaultValue, this.props, checkValueConstructor && !this.warned) || [] });
      } else {
        this._selectOptionAtBeginningHandler();
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      // 点击了非控件内区域  关闭弹窗
      this.removeMenu = function (e) {
        if (!_this2.state.visible || !_this2.refs.container) {
          return;
        }
        var popup = _this2.refs.trigger && _this2.refs.trigger.getPopupDOMNode();
        if (!((0, _reactDom.findDOMNode)(_this2.refs.container).contains(e.target) || popup && popup.contains(e.target))) {
          _this2.hideDropdown();
        }
      };
      window.addEventListener('click', this.removeMenu, true);
      window.addEventListener('resize', this.resizeCalc, false);
      this.calculateNodeWidth();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      //如果有value设置同步
      if (nextProps.hasOwnProperty('value') && nextProps.value !== undefined) {
        this.props.checkValueConstructor && (this.warned = true);
        this.setState({ value: (0, _util3.getRenderValue)(nextProps.value, this.props, this.props.checkValueConstructor && !this.warned) }, this.calculateNodeWidth);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      //每次组件更新重算input宽度，处理didMount时无滚动条之后又出现的情况
      //需要重置记忆的高度, 弹出框才能重新定位
      this.resizeCalc();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      // 卸载后将延时器清掉
      this.timeout && clearTimeout(this.timeout);
      window.removeEventListener('click', this.removeMenu, true);
      window.removeEventListener('resize', this.resizeCalc, false);
    }

    // 供多选使用 记忆当前多选框的高度和宽度


    /**
     * 获取默认的高亮条目
     */


    /**
     * 当前数据中全部被选中  高亮全选, 否则灰掉全选
     * @param {selectedArray} 当前已选中的条目
     * @param {showData} 当前可选的条目
     * @returns {boolean} 当前是否需要高亮全选
     */


    /**
     * 点击清空按钮 进行清空当前选中的值
     *  清除后使输入框再次获得焦点
     * @param e
     */


    /**
     * 搜索
     *  如果是联想模式, 同时改变它的 value, 并在 trigger 为 onChange 时触发响应校验
     * @param e
     */


    /**
     * 单选和联想模式的选择  选择后关闭下拉窗
     * @param index 当前选中条目在下拉选项中的索引
     * @param e
     */


    /**
     * 多选模式的选择
     *  如果有设置 checkbox, 选择后删除这条数据,删除后恢复这条数据
     * @param index 当前选中条目在下拉选项中的索引
     * @param e
     * @private valueIndex 当前传入的条目在已选择的集合中的索引
     */


    /**
     * 取消选中某项
     *  如果没有设置 checkbox, 取消选择后会将这一条数据显示在列表里
     * @param index 删除的条目在当前选中的集合中的索引
     * @param e 当前事件
     * @param callback 回调函数
     */


    /**
     * 点击删除按钮删除已选中的条目 并校验有效性
     * @param index 删除的条目在当前选中的集合中的索引
     */


    /**
     * 全选/全不选
     * @param checked 是否当前在全选状态
     */


    /**
     * 关闭弹窗 并清空搜索关键字
     *  对于多选模式, 只做校验
     *  对于单选模式, 如果没有选择值的话, 会把 focus 时置成提示的值再重新置回来
     *  对于联想模式, 会把当前选择的值转换成 string 传递出去, 如果有设置 trigger 为 onBlur 的话, 会触发相应的校验事件
     * @param e
     */


    /**
     * 显示弹窗 并判断是否重新获取下拉列表的数据
     *  对于单选模式, 将当前选中的值置成 placeholder 提示显示
     * @param e
     */


    /**
     * 获取数据 延时搜索,并在搜索时显示转圈loading
     *  多选情况下,如果超过可选条数,则不发搜索请求
     * @param filter 搜索关键字
     * @param callback 回调函数
     * @private
     */

    /**
     * 一开始就去获取数据并选中一项
     */


    /**
     * 键选
     *  多选状态下  如果没有关键字时  delete键会执行删除操作
     * @param e
     */


    /**
     * 更新焦点
     *  当鼠标进入时 清除上下键焦距的条目
     *  上下键选时, 使获得焦点的选项可见
     * @param e
     */

  }, {
    key: 'renderSelect',


    // 渲染输入框
    value: function renderSelect() {
      var _classNames, _classNames2;

      var _props2 = this.props;
      var prefixCls = _props2.prefixCls;
      var size = _props2.size;
      var disabled = _props2.disabled;
      var placeholder = _props2.placeholder;
      var mode = _props2.mode;
      var clearIcon = _props2.clearIcon;
      var combobox = _props2.combobox;
      var emptyLable = _props2.emptyLable;
      var multiple = _props2.multiple;
      var unsearchable = _props2.unsearchable;
      var noSearchIfNoKeyword = _props2.noSearchIfNoKeyword;
      var domProps = _props2.domProps;
      var _state = this.state;
      var value = _state.value;
      var visible = _state.visible;
      var searchword = _state.searchword;
      var valid = _state.valid;

      prefixCls = prefixCls + '-select' + (multiple ? '-multiple' : '');
      unsearchable = !combobox && unsearchable;
      var showAngleDown = (0, _util3.isSingleMode)(this.props) && (!noSearchIfNoKeyword || this.searching && !(0, _data.isEmptyString)(searchword));
      var outerCls = (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, prefixCls + '-input', true), _defineProperty(_classNames, prefixCls + '-input-unsearchable', unsearchable), _defineProperty(_classNames, prefixCls + '-input-disabled', mode !== 'view' && disabled), _defineProperty(_classNames, prefixCls + '-input-sm', size === 'small'), _defineProperty(_classNames, prefixCls + '-input-angle', showAngleDown), _defineProperty(_classNames, 'has-error', !valid), _classNames));

      value = multiple ? value : (0, _util3.getShowValue)(value);
      var showLabel = '';
      if (multiple) {
        // 多选  一直显示搜索关键字
        showLabel = searchword;
      } else if (combobox) {
        showLabel = value.label;
      } else {
        // 单选, 搜索时显示搜索关键字, 否则显示选中项的文本
        showLabel = value.label;
        placeholder = "";
      }
      var showClear = !multiple && !disabled && clearIcon && !(0, _data.isEmptyString)(value.value);

      if (mode === 'view' || disabled) {
        showLabel = (0, _data.getString)(showLabel) || emptyLable;
        if (disabled && (multiple ? (value || []).length === 0 : (0, _data.isEmptyString)(showLabel))) {
          outerCls += ' ' + prefixCls + '-placeholder';
          showLabel = this.props.placeholder;
        }
        return _react2.default.createElement(
          'div',
          { className: outerCls },
          showLabel || '\xa0',
          mode !== 'view' && showAngleDown && _react2.default.createElement('i', { className: prefixCls + '-arrow ' + _data.IconPrefixCls + ' ' + _data.IconPrefixCls + '-angle-down' })
        );
      }

      var arrowHandler = !disabled && (visible ? this.hideDropdown : this.focusInput);
      return _react2.default.createElement(
        'div',
        { className: outerCls, ref: 'inputWrap', title: multiple ? '' : showLabel },
        (unsearchable || (0, _util3.isSingleMode)(this.props)) && _react2.default.createElement(
          'div',
          { ref: multiple ? "input" : "label", className: (0, _classnames2.default)((_classNames2 = {}, _defineProperty(_classNames2, prefixCls + '-searching', this.searching), _defineProperty(_classNames2, prefixCls + '-placeholder', !unsearchable && this.searching || !showLabel), _defineProperty(_classNames2, prefixCls + '-label', true), _classNames2)), onClick: this._focusHandle },
          searchword ? '' : showLabel || this.props.placeholder
        ),
        !unsearchable && _react2.default.createElement('input', _extends({}, domProps, {
          ref: 'input',
          value: (0, _util3.isSingleMode)(this.props) ? searchword : showLabel || '',
          placeholder: placeholder,
          disabled: disabled,
          onChange: this._changeHandle,
          onBlur: this._blurHandle,
          onFocus: this._focusHandle,
          onKeyDown: this._keyDownHandle
        })),
        showClear && _react2.default.createElement('i', { className: prefixCls + '-input-clearIcon ' + _data.IconPrefixCls + ' ' + _data.IconPrefixCls + '-cross-circle',
          onClick: this._clearDataHandle }),
        showAngleDown && _react2.default.createElement('i', { className: prefixCls + '-arrow ' + _data.IconPrefixCls + ' ' + _data.IconPrefixCls + '-angle-down', onClick: arrowHandler })
      );
    }

    // 渲染多选

  }, {
    key: 'renderMultiSelect',
    value: function renderMultiSelect() {
      var _this3 = this;

      var _props3 = this.props;
      var disabled = _props3.disabled;
      var mode = _props3.mode;
      var prefixCls = _props3.prefixCls;
      var emptyLabel = _props3.emptyLabel;
      var separator = _props3.separator;
      var value = this.state.value;

      prefixCls = prefixCls + '-select-multiple';
      var outerCls = (0, _classnames2.default)(_defineProperty({}, prefixCls + '-selection', true));
      var hasValue = (value || []).length > 0;
      if (mode === 'view') {
        var showLabel = hasValue ? value.map(function (v) {
          return v.label;
        }).join(separator + " ") : emptyLabel;
        return _react2.default.createElement(
          'div',
          { className: outerCls },
          showLabel
        );
      }
      return _react2.default.createElement(
        'div',
        { className: outerCls, ref: 'selection', onClick: this.focusInput },
        hasValue && _react2.default.createElement(
          'ul',
          null,
          value.map(function (v, k) {
            return _react2.default.createElement(
              'li',
              { key: k, onClick: _data.stopPropagationEvent },
              _react2.default.createElement(
                'span',
                null,
                v.label
              ),
              !disabled && _react2.default.createElement('i', { className: prefixCls + '-delete ' + _data.IconPrefixCls + ' ' + _data.IconPrefixCls + '-cross',
                onClick: _this3._removeHandle.bind(_this3, k) })
            );
          })
        ),
        this.renderSelect(prefixCls)
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames4,
          _this4 = this;

      var props = _extends({}, this.props);
      var prefixCls = props.prefixCls;
      var triggerClassName = props.triggerClassName;
      var className = props.className;
      var size = props.size;
      var disabled = props.disabled;
      var style = props.style;
      var mode = props.mode;
      var combobox = props.combobox;
      var multiple = props.multiple;
      var maxLength = props.maxLength;
      var showCount = props.showCount;
      var getPopupContainer = props.getPopupContainer;
      var align = props.align;
      var notFoundContent = props.notFoundContent;
      var noSearchIfNoKeyword = props.noSearchIfNoKeyword;
      var _state2 = this.state;
      var visible = _state2.visible;
      var valid = _state2.valid;
      var explain = _state2.explain;
      var showData = _state2.showData;
      var loading = _state2.loading;
      var searchword = _state2.searchword;
      var value = _state2.value;
      var fetchErrorMessage = _state2.fetchErrorMessage;

      prefixCls += '-select' + (multiple ? '-multiple' : '');
      var showTrigger = mode !== 'view' && !disabled;

      var cls = (0, _classnames2.default)((_classNames4 = {}, _defineProperty(_classNames4, '' + prefixCls, true), _defineProperty(_classNames4, prefixCls + '-combobox', combobox), _defineProperty(_classNames4, prefixCls + '-sm', size === 'small'), _defineProperty(_classNames4, prefixCls + '-' + mode, mode === 'view'), _defineProperty(_classNames4, prefixCls + '-disabled', mode !== 'view' && disabled), _defineProperty(_classNames4, prefixCls + '-visible', visible), _defineProperty(_classNames4, className, className), _defineProperty(_classNames4, 'has-error', !valid), _classNames4));
      var hasData = (showData || []).length > 0;
      if (visible) {
        if (!hasData && (combobox || !loading && (0, _data.isEmptyString)(notFoundContent))) {
          // 联想输入框没数据时, 或者 notFoundContent 为空且无数据时, 都不显示下拉窗
          visible = false;
        }
        if (this.searching && (0, _data.isEmptyString)(combobox ? value : searchword) && noSearchIfNoKeyword) {
          // noSearchIfNoKeyword 为 true 而关键字为空时不显示下拉窗
          visible = false;
        }
      }
      var countContent = void 0;
      if (combobox && mode !== "view" && showCount) {
        var _classNames5;

        // 联想输入框编辑态实时计数
        value = (0, _util3.getShowValue)(value);
        var labelLength = value.label.length;
        var showCountCls = combobox && (0, _classnames2.default)((_classNames5 = {}, _defineProperty(_classNames5, prefixCls + '-showCount', true), _defineProperty(_classNames5, prefixCls + '-showCount-overCount', labelLength > maxLength), _classNames5));
        countContent = _react2.default.createElement(
          'span',
          { className: showCountCls },
          _react2.default.createElement(
            'i',
            null,
            labelLength
          ),
          '/',
          maxLength
        );
      }
      return _react2.default.createElement(
        'div',
        { className: cls, style: style, ref: 'container' },
        multiple ? this.renderMultiSelect() : this.renderSelect(),
        countContent,
        !valid && _react2.default.createElement(
          'span',
          { className: 'has-explain ' + prefixCls + '-explain' },
          explain
        ),
        showTrigger && _react2.default.createElement(
          _trigger2.default,
          { visible: visible,
            className: triggerClassName,
            align: align,
            ref: 'trigger',
            autoDestory: align ? align.autoDestory : true,
            equalTargetWidth: align ? align.equalTargetWidth : true,
            getPopupContainer: getPopupContainer,
            target: function target() {
              return (0, _reactDom.findDOMNode)(_this4);
            } },
          _react2.default.createElement(Select.TriggerContent, _extends({}, props, this.state, { loading: loading,
            parent: this,
            notFoundContent: fetchErrorMessage || notFoundContent,
            ref: 'triggerContent' }))
        )
      );
    }

    /**
     * 校验 外部校验时所有的都触发
     * @param type 校验的时机
     * @returns {boolean}
     */

    /**
     * 响应校验的事件 只对 combobox 类型有效
     * @param rules 需要校验的规则集合
     */


    /**
     * 重置控件，清空数据并清空校验状态
     */


    /**
     * 清空异常状态，校验提示等
     */


    /**
     * 清空下拉数据
     */


    /**
     * 刷新数据
     * @param data 需要刷新成的数据
     * @param callback 回调函数
     */

    /**
     * 获取当前的下拉可选项
     */


    /**
     * 使输入框获得焦点
     */


    /**
     * 使输入框失去焦点
     */


    /**
     * 隐藏弹窗
     */

  }]);

  return Select;
}(_util2.default.BaseComponent), _class.propTypes = {
  prefixCls: _propTypes2.default.string,
  triggerClassName: _propTypes2.default.string,
  mode: _propTypes2.default.oneOf(['default', 'view']),
  combobox: _propTypes2.default.bool,
  multiple: _propTypes2.default.bool,
  unsearchable: _propTypes2.default.bool,
  value: _propTypes2.default.oneOfType([valueObjectShape, _propTypes2.default.arrayOf(valueObjectShape)]),
  defaultValue: _propTypes2.default.oneOfType([valueObjectShape, _propTypes2.default.arrayOf(valueObjectShape)]),
  model: modelObjectShape,
  size: _propTypes2.default.oneOf(['default', 'small']),
  trigger: _propTypes2.default.string,
  placeholder: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  required: _propTypes2.default.bool,
  validation: _propTypes2.default.string,
  showCount: _propTypes2.default.bool,
  maxLength: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  overLengthValidation: _propTypes2.default.string,
  cutIfOverLength: _propTypes2.default.bool,
  cutIfDisMatchPattern: _propTypes2.default.bool,
  validator: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object]),
  clearIcon: _propTypes2.default.bool,
  selectOnlyOptionAtBeginning: _propTypes2.default.bool,
  selectFirstOptionAtBeginning: _propTypes2.default.bool,
  focusAfterClear: _propTypes2.default.bool,
  focusAfterSelect: _propTypes2.default.bool,
  clearSearchwordAfterSelect: _propTypes2.default.bool,
  notFoundContent: _propTypes2.default.string,
  codesToShowFetchError: _propTypes2.default.array,
  noCache: _propTypes2.default.bool,
  noChangeIfDuplicated: _propTypes2.default.bool,
  noSearchIfNoKeyword: _propTypes2.default.bool,
  defaultActiveFirstOption: _propTypes2.default.bool,
  delay: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  separator: _propTypes2.default.string,
  checkbox: _propTypes2.default.bool,
  allCheck: _propTypes2.default.bool,
  emptyLabel: _propTypes2.default.string,
  align: _propTypes2.default.object,
  getPopupContainer: _propTypes2.default.func,
  fetchDataAction: _propTypes2.default.func,
  onFetchData: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  onSelect: _propTypes2.default.func,
  onDeselect: _propTypes2.default.func,
  onSearch: _propTypes2.default.func,
  onClear: _propTypes2.default.func,
  onKeyDown: _propTypes2.default.func,
  domProps: _propTypes2.default.object,
  checkValueConstructor: _propTypes2.default.bool
}, _class.defaultProps = {
  prefixCls: 'mt',
  triggerClassName: "", // 直接传给 trigger 的样式名称
  mode: 'default', // 设置控件的查看状态，可选值为 default|view 或者不设
  combobox: false, // 是否是联想模式
  multiple: false, // 是否多选
  unsearchable: false, // 不支持搜索
  model: {
    idField: 'value',
    showField: 'label',
    disabledField: 'disabled'
  }, // 显示的配置
  size: null, // 设置输入框大小，可选值为 small 或者不设
  trigger: 'onBlur', // 触发 onChange 的时机，可选值为 onBlur|onChange, 只对 `combobox` 有效
  placeholder: '', // 默认提示
  disabled: false, // 设置控件的禁用状态
  required: false, // 设置控件是否必填
  validation: null, // 未填时的提示
  validator: null, // 校验的配置, `validator` object态只对 `combobox` 有效
  clearIcon: true, // 是否显示清空按钮
  selectOnlyOptionAtBeginning: false, // 是否一开始就去获取数据, 并在只有一条时选中它
  selectFirstOptionAtBeginning: false, // 是否一开始就去获取数据, 并选中第一条
  focusAfterClear: true, // 清空后是否使输入框获得焦点
  focusAfterSelect: true, // 选择一项后是否使输入框获得焦点
  clearSearchwordAfterSelect: false, // 对 `multiple` 有效, 设置是否在选择一项后清空搜索关键字
  showCount: false, // 是否显示长度限制，只对 `combobox` 有效
  maxLength: Infinity, // 对 `multiple` 而言是指最大可选个数, 对 `combobox` 而言是指最大字符数
  overLengthValidation: "超过最大字符数", // 超过最大字符限制, 只对 `combobox` 有效
  cutIfOverLength: false, // 是否超过最大长度截断, 只对 `combobox` 有效
  cutIfDisMatchPattern: false, // 是否不符合校验的字符截断, 只对 `combobox` 有效
  noChangeIfDuplicated: true, // 设置在选择同一项时不触发 onChange
  notFoundContent: '无数据', // 有搜索值时, 下拉列表为空显示的提示
  codesToShowFetchError: null, // 当搜索失败时结果中某些指定数据存在, 在弹框中显示失败的 message
  noCache: false, // 是否不缓存
  noSearchIfNoKeyword: false, // 空串不搜索
  defaultActiveFirstOption: false, //是否默认高亮第一个选项
  delay: 500, // 延迟搜索，避免目标明确的输入多次联想
  separator: ",", // 只读时的分隔符, 只对 `multiple` 有效
  checkbox: true, // 是否显示 checkbox, 只对 `multiple` 有效, 如果设置为false, 则选择过的数据不会显示在列表里
  allCheck: false, // 是否显示全选按钮, 配合 checkbox 一起使用, 只对 `multiple` 有效
  emptyLabel: '', // mode 为 view 时,显示的文字
  getPopupContainer: null, // 弹出框要弹出到的父节点
  fetchDataAction: null, // 键入搜索条件时搜索
  onFetchData: _data.noop, // 键入搜索条件时搜索
  onChange: _data.noop, // 值改变时触发事件
  onFocus: _data.noop, // 获得焦点触发事件
  onBlur: _data.noop, // 失去焦点触发事件
  onSelect: _data.noop, // 选择一项触发事件
  onDeselect: _data.noop, // 取消选择时触发的事件, 只对 `multiple` 有效
  onSearch: _data.noop, // 搜索时触发事件
  onClear: _data.noop, // 清空时触发事件
  onKeyDown: _data.noop, // 响应键盘敲击事件
  domProps: {}, // 传递给 input 原生的属性
  checkValueConstructor: true }, _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.resizeCalc = function () {
    var _props4 = _this5.props;
    var multiple = _props4.multiple;
    var disabled = _props4.disabled;
    var mode = _props4.mode;

    if (disabled || mode === 'view') return;
    if (multiple) {
      // 先把input的宽度调小,这样外层的selection的宽度才是正常的, 避免屏幕缩小时算不对,避免trigger位置不对
      (0, _reactDom.findDOMNode)(_this5.refs.input).style.width = '50px';
      _this5._rememberSelectionHeight();
    }
    _this5.calculateNodeWidth();
  };

  this.calculateNodeWidth = function () {
    var _props5 = _this5.props;
    var multiple = _props5.multiple;
    var disabled = _props5.disabled;
    var mode = _props5.mode;

    if (disabled || mode === 'view') return;
    if (multiple) {
      var _refs = _this5.refs;
      var selection = _refs.selection;
      var trigger = _refs.trigger;
      var input = _refs.input;

      (0, _util3.calculateInputWidth)(selection, input);
      if (selection.offsetHeight !== _this5.lastHeight || selection.offsetWidth !== _this5.lastWidth) {
        trigger.forceAlign();
      }
    }
  };

  this._rememberSelectionHeight = function () {
    var _ref2 = (0, _reactDom.findDOMNode)(_this5.refs.selection) || {};

    var offsetWidth = _ref2.offsetWidth;
    var offsetHeight = _ref2.offsetHeight;

    _this5.lastHeight = offsetHeight;
    _this5.lastWidth = offsetWidth;
  };

  this._getDefaultAO = function () {
    var showData = _this5.state.showData;
    var disabledField = _this5.props.model.disabledField;

    if (!_this5.props.defaultActiveFirstOption || (showData || []).length === 0) {
      _this5._updateActiveOptionHandle(null);
      return;
    }
    if (!showData[0][disabledField]) {
      _this5._updateActiveOptionHandle(0);
      return;
    }
    var activeOptionIndex = 0;
    var index = 0;
    var length = (showData || []).length;
    do {
      index = Math.min(length - 1, index + 1);
      if (!showData[index][disabledField]) {
        activeOptionIndex = index;
        break;
      }
    } while (index + 1 < length);
    _this5._updateActiveOptionHandle(activeOptionIndex);
  };

  this._isAllSelect = function (selectedArray, showData) {
    if (!(0, _util3.isAllSelectShow)(_this5.props)) {
      return;
    }
    showData = showData || _this5.state.showData || [];
    var value = selectedArray || _this5.state.value || [];
    return showData.every(function (v) {
      return value.some(function (item) {
        return item.value === v.value;
      });
    });
  };

  this._clearDataHandle = function (e) {
    var _props6 = _this5.props;
    var multiple = _props6.multiple;
    var combobox = _props6.combobox;
    var focusAfterClear = _props6.focusAfterClear;
    var onClear = _props6.onClear;
    var onChange = _props6.onChange;

    if (multiple) {
      return;
    }
    var value = combobox ? '' : (0, _util3.getShowValue)();
    _this5.setState({ value: value, searchword: '' }, function () {
      if (focusAfterClear) {
        // 输入框获得焦点
        _this5._fetchDataHandle();
        _this5.focusInput();
      }
    });
    onClear && onClear(e);
    onChange && onChange(value, e);
    // 阻止 input 发生点击事件
    (0, _data.stopPropagationEvent)(e);
  };

  this._changeHandle = function (e) {
    var _props7 = _this5.props;
    var onSearch = _props7.onSearch;
    var trigger = _props7.trigger;
    var combobox = _props7.combobox;
    var multiple = _props7.multiple;
    var onChange = _props7.onChange;
    var maxLength = _props7.maxLength;
    var cutIfOverLength = _props7.cutIfOverLength;
    var cutIfDisMatchPattern = _props7.cutIfDisMatchPattern;
    var pattern = _props7.pattern;

    var state = _extends({}, _this5.state);
    var value = _lodashCompat2.default.cloneDeep(state.value);
    if (multiple && (value || []).length >= maxLength) {
      return;
    }
    var searchword = e.target.value;
    if (combobox) {
      if (pattern && cutIfDisMatchPattern) {
        // 如果需要截止不符合校验的字符
        var regexp = (0, _data.getPattern)(pattern);
        if (regexp && !regexp.test(searchword)) {
          return;
        }
      }
      value = searchword;
      if (cutIfOverLength && searchword.length > maxLength) {
        // 输入/粘贴时截断
        value = searchword.substring(0, maxLength);
      }
    }
    _this5.setState({ searchword: searchword, value: value }, function () {
      _this5._fetchDataHandle(searchword, function () {
        onSearch(searchword, e);
        combobox && _this5.validate("onChange");
      });
    });
    combobox && trigger === 'onChange' && onChange(value, e);
  };

  this._selectHandle = function (index, callback, e) {
    var _props8 = _this5.props;
    var combobox = _props8.combobox;
    var onSelect = _props8.onSelect;
    var onChange = _props8.onChange;
    var noChangeIfDuplicated = _props8.noChangeIfDuplicated;

    var state = _extends({}, _this5.state);
    var value = (state.showData || [])[index];
    if (!value) {
      return;
    }
    if (combobox) {
      value = value.label;
    } else {
      if (noChangeIfDuplicated && (0, _util3.isSingleMode)(_this5.props) && (0, _util3.getShowValue)(state.value).value === value.value) {
        // 单选并且选择了同一项
        _this5.hideDropdown();
        callback && callback();
        onSelect(value, e);
        return;
      }
    }
    _this5.setState({ value: value }, function () {
      _this5.hideDropdown();
      callback && callback();
      if (combobox) {
        _this5.validate('onChange');
        _this5.validate('onBlur');
      }
    });
    onSelect(value, e);
    onChange(value, e);
  };

  this._multiSelectHandle = function (index, callback, e) {
    var _state3 = _this5.state;
    var allSelect = _state3.allSelect;
    var searchword = _state3.searchword;
    var _props9 = _this5.props;
    var checkbox = _props9.checkbox;
    var onChange = _props9.onChange;
    var onSelect = _props9.onSelect;
    var maxLength = _props9.maxLength;
    var clearSearchwordAfterSelect = _props9.clearSearchwordAfterSelect;
    var focusAfterSelect = _props9.focusAfterSelect;

    var value = _lodashCompat2.default.cloneDeep(_this5.state.value || []),
        showData = (_this5.state.showData || []).slice();
    var item = showData[index];
    if (!item) {
      // 无数据 enter 时, item 为 undefined
      return;
    }
    var valueIndex = value.findIndex(function (v) {
      return v.value === item.value;
    });
    if (valueIndex !== -1) {
      // 删除已选择的条目
      _this5._multiDeSelectHandle(valueIndex, e);
    } else {
      var _ret = function () {
        // 添加一条选项
        if ((0, _data.isEmptyString)(item.value)) {
          // 如果快速双击, 第二次的点击也会处理一遍添加的逻辑, 此时做一下保护
          return {
            v: void 0
          };
        }
        var currentLength = value.length;
        if (currentLength + 1 > maxLength) {
          return {
            v: void 0
          };
        }
        value = currentLength > 0 ? value.concat(item) : [item];
        // 如果没有 checkbox, 选择后这一条数据筛选掉
        if (!checkbox) {
          showData.splice(index, 1);
        }
        allSelect = _this5._isAllSelect(value);
        var oldSearch = searchword;
        clearSearchwordAfterSelect && (searchword = "");
        _this5.setState({ value: value, showData: showData, searchword: searchword, allSelect: allSelect }, function () {
          //this.resizeCalc();  componentDidUpdate 监听数据的改变
          if (clearSearchwordAfterSelect && oldSearch) {
            _this5._fetchDataHandle();
          }
          callback && callback();
        });
        onSelect(item, e);
        onChange(value, e);
      }();

      if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
    }
    focusAfterSelect && _this5.focusInput();
  };

  this._multiDeSelectHandle = function (index, e, callback) {
    var _state4 = _this5.state;
    var allSelect = _state4.allSelect;
    var data = _state4.data;

    var value = _lodashCompat2.default.cloneDeep(_this5.state.value || []),
        showData = (_this5.state.showData || []).slice();
    if (!value[index]) {
      return;
    }
    var _props10 = _this5.props;
    var onChange = _props10.onChange;
    var onDeselect = _props10.onDeselect;
    var checkbox = _props10.checkbox;
    var model = _props10.model;
    // 如果没有 checkbox, 删除后将这一条数据渲染出来

    var option = value[index];
    value.splice(index, 1);
    var newData = data.filter(function (v) {
      return showData.some(function (item) {
        return item.value === v[model.idField];
      }) || v[model.idField] === option.value;
    });
    if (!checkbox) {
      showData = (0, _util3.getShowData)(newData, _this5.props, value);
    }
    allSelect = _this5._isAllSelect(value);
    _this5.setState({ value: value, showData: showData, allSelect: allSelect }, function () {
      //this.resizeCalc();  componentDidUpdate 监听改变
      _lodashCompat2.default.isEmpty(_this5.state.showData) && _this5._fetchDataHandle();
      callback && callback();
    });
    onChange(value, e);
    onDeselect(option, e);
  };

  this._removeHandle = function (index, e) {
    _this5._multiDeSelectHandle(index, e, _this5.validate);
    (0, _data.stopPropagationEvent)(e);
  };

  this._allSelectHandle = function (checked) {
    var _state5 = _this5.state;
    var allSelect = _state5.allSelect;
    var showData = _state5.showData;

    var value = _lodashCompat2.default.cloneDeep(_this5.state.value || []);
    allSelect = !checked;
    if (value.length === 0) {
      value = checked ? [] : showData || [];
    } else {
      if (!checked) {
        value = value.concat((showData || []).filter(function (v) {
          return value.every(function (opt) {
            return opt.value !== v.value;
          });
        }));
      } else {
        value = value.filter(function (opt) {
          return (showData || []).every(function (v) {
            return v.value !== opt.value;
          });
        });
      }
    }
    var onChange = _this5.props.onChange;

    _this5._rememberSelectionHeight();
    _this5.setState({ value: value, allSelect: allSelect }, function () {
      _this5.calculateNodeWidth();
    });
    onChange(value);
  };

  this._blurHandle = function (e) {
    var _props11 = _this5.props;
    var multiple = _props11.multiple;
    var combobox = _props11.combobox;
    var onChange = _props11.onChange;
    var onBlur = _props11.onBlur;
    var trigger = _props11.trigger;

    if (multiple) {
      onBlur(e);
      return;
    }
    var value = _lodashCompat2.default.cloneDeep(_this5.state.value || []);
    if (combobox) {
      value = (0, _util3.getShowValue)(value).value;
    }
    _this5.setState({ value: value }, function () {
      if (combobox) {
        // 联想类型需要处理校验
        _this5.validate("onBlur");
      }
    });
    combobox && trigger === 'onBlur' && onChange(value, e);
    onBlur(e);
  };

  this._focusHandle = function (e) {
    var _props12 = _this5.props;
    var combobox = _props12.combobox;
    var onFocus = _props12.onFocus;
    var noCache = _props12.noCache;
    var _state6 = _this5.state;
    var showData = _state6.showData;
    var value = _state6.value;
    var searchword = _state6.searchword;

    var filter = combobox ? value : searchword;
    _this5.searching = true;
    _this5._rememberSelectionHeight();
    _this5.setState({ visible: true, valid: true }, function () {
      if (noCache || !showData) {
        _this5._fetchDataHandle(filter || "", function () {
          _this5.calculateNodeWidth();
          onFocus(e);
        });
      } else {
        _this5.calculateNodeWidth();
        onFocus(e);
      }
    });
  };

  this._fetchDataHandle = function (filter, callback) {
    var _props13 = _this5.props;
    var multiple = _props13.multiple;
    var fetchDataAction = _props13.fetchDataAction;
    var onFetchData = _props13.onFetchData;
    var delay = _props13.delay;
    var maxLength = _props13.maxLength;
    var align = _props13.align;
    var noSearchIfNoKeyword = _props13.noSearchIfNoKeyword;
    var codesToShowFetchError = _props13.codesToShowFetchError;

    if (noSearchIfNoKeyword && (0, _data.isEmptyString)(filter)) {
      return;
    }
    if (multiple && (_this5.state.value || []).length + 1 > maxLength) {
      return;
    }
    var showLoading = delay > 0; // 如果 delay === 0, 直接不显示 loading 转圈
    _this5._updateActiveOptionHandle();
    _this5.setState({ loading: showLoading }, function () {
      showLoading && align && _this5.refs.trigger.forceAlign();
    });
    _this5.timeout && clearTimeout(_this5.timeout);
    _this5.timeout = setTimeout(function () {
      (fetchDataAction || onFetchData)(filter || '', _this5.raceSafe(function (data) {
        showLoading && Object.assign(_this5.state, { loading: false });
        Object.assign(_this5.state, { fetchErrorMessage: '' });
        _this5.fillOptions(data, callback);
      }, 'fetchData'), _this5.raceSafe(function (res) {
        showLoading && Object.assign(_this5.state, { loading: false });
        if (Array.isArray(codesToShowFetchError) && _lodashCompat2.default.isObject(res)) {
          Object.assign(_this5.state, { fetchErrorMessage: (0, _util3.isFindInArray)(codesToShowFetchError, res) && res.message || '' });
        }
        _this5.fillOptions([], callback);
      }, 'fetchDataFailed'));
    }, delay);
  };

  this._selectOptionAtBeginningHandler = function () {
    if (!_this5._isSelectOptionAtBeginning()) return;
    // 去获取数据, 判断是否只有一条, 如果是, 选中
    _this5._fetchDataHandle("", function () {
      var _props14 = _this5.props;
      var selectOnlyOptionAtBeginning = _props14.selectOnlyOptionAtBeginning;
      var selectFirstOptionAtBeginning = _props14.selectFirstOptionAtBeginning;

      var showData = _this5.state.showData || [],
          length = showData.length;
      if (selectOnlyOptionAtBeginning && length === 1 || selectFirstOptionAtBeginning && length > 0) {
        var firstOption = showData[0];
        if (!firstOption.value) {
          return;
        }
        _this5.setState({ value: firstOption });
        _this5.props.onChange(firstOption);
      }
    });
  };

  this._isSelectOptionAtBeginning = function () {
    return !_this5.state.value && (0, _util3.isSingleMode)(_this5.props) && (_this5.props.selectOnlyOptionAtBeginning || _this5.props.selectFirstOptionAtBeginning);
  };

  this._keyDownHandle = function (e) {
    var props = _this5.props;
    var multiple = props.multiple;
    var onKeyDown = props.onKeyDown;
    var model = props.model;

    var _state7 = _extends({}, _this5.state);

    var value = _state7.value;
    var showData = _state7.showData;
    var loading = _state7.loading;
    var disabledField = model.disabledField;

    var triggerContent = _this5.refs.triggerContent;
    onKeyDown = onKeyDown && onKeyDown.bind(null, e);
    if (e.keyCode !== _data.KEYCODE.BACKSPACE && !triggerContent) {
      onKeyDown && onKeyDown();
      return;
    }
    var activeOptionIndex = triggerContent ? triggerContent.getActiveOptionIndex() : null;
    showData = showData || [];
    var length = (showData || []).length;
    var index = activeOptionIndex;
    switch (e.keyCode) {
      case _data.KEYCODE.BACKSPACE:
        // 多选时当前搜索框里没值时, 删除按钮可删除最近选择的条目
        multiple && !e.target.value && value && value.length > 0 && _this5._multiDeSelectHandle(value.length - 1, e);
        break;
      case _data.KEYCODE.ARROW_UP:
        do {
          // 跳过禁用的条目
          index = Math.max(0, index - 1);
          if (!showData[index][disabledField]) {
            activeOptionIndex = index;
            break;
          }
        } while (index > 0);
        _this5._updateActiveOptionHandle(activeOptionIndex, function () {
          var ele = (0, _reactDom.findDOMNode)(triggerContent.refs["option_" + activeOptionIndex]);
          ele && ele.scrollIntoViewIfNeeded(false);
        });
        onKeyDown(showData[activeOptionIndex]);
        break;
      case _data.KEYCODE.ARROW_DOWN:
        do {
          index = Math.min(length - 1, index + 1);
          if (!showData[index][disabledField]) {
            activeOptionIndex = index;
            break;
          }
        } while (index + 1 < length);
        _this5._updateActiveOptionHandle(activeOptionIndex, function () {
          var ele = (0, _reactDom.findDOMNode)(triggerContent.refs["option_" + activeOptionIndex]);
          ele && ele.scrollIntoViewIfNeeded(false);
        });
        onKeyDown(showData[activeOptionIndex]);
        break;
      case _data.KEYCODE.ENTER:
        if (loading || activeOptionIndex === null || length === 0) {
          onKeyDown();
          return;
        }
        if (multiple) {
          _this5._multiSelectHandle(activeOptionIndex, null, e);
          onKeyDown(showData[activeOptionIndex]);
        } else {
          _this5._selectHandle(activeOptionIndex, null, e);
          onKeyDown(showData[activeOptionIndex]);
          setTimeout(_this5.blurInput, 0);
        }
        break;
      default:
        onKeyDown();
    }
  };

  this._updateActiveOptionHandle = function (index, callback) {
    var ref = _this5.refs.triggerContent;
    if (!ref) {
      return;
    }
    ref.setActiveOption && ref.setActiveOption(index);
    index != null && callback && callback();
  };

  this.validate = function (type) {
    var _props15 = _this5.props;
    var mode = _props15.mode;
    var required = _props15.required;
    var pattern = _props15.pattern;
    var maxLength = _props15.maxLength;
    var overLengthValidation = _props15.overLengthValidation;
    var validation = _props15.validation;
    var multiple = _props15.multiple;
    var combobox = _props15.combobox;
    var validator = _this5.props.validator;

    if (mode === 'view') {
      !_this5.state.valid && _this5.setState({ valid: true });
      return true;
    }
    var flag = true,
        value = _this5.state.value,
        explain = '';
    //非空校验和自定义校验

    if (type !== "onChange" && required) {
      var noValue = false;
      if (multiple) {
        noValue = (0, _data.toArray)(value).length === 0;
      } else if (combobox) {
        noValue = !value;
      } else {
        noValue = !value || (0, _data.isEmptyString)((0, _util3.getShowValue)(value).value);
      }
      if (noValue) {
        explain = validation || '';
        flag = false;
      }
    }
    if (flag && type !== "onChange" && combobox) {
      var preRules = [];
      pattern && preRules.push({ pattern: pattern, message: validation });
      maxLength !== Infinity && maxLength && preRules.push({ maxLength: maxLength, message: overLengthValidation });
      flag = _this5.doValidate(type, preRules);
    }

    if (flag && validator) {
      //自定义校验
      if (combobox) {
        if ((0, _data.isFunction)(validator)) {
          validator = {
            "onBlur": [{ validator: _this5.props.validator }]
          };
        }
        var blurRule = validator['onBlur'] || [];
        var changeRule = validator['onChange'] || [];
        if (type == "onChange") {
          _this5.doValidate(type, changeRule);
        } else if (type == "onBlur") {
          _this5.doValidate(type, blurRule);
        } else {
          _this5.doValidate(type, blurRule.concat(changeRule));
        }
        _this5.forceUpdate();
        return _this5.state.valid;
      }
      if ((0, _data.isFunction)(validator)) {
        explain = _this5.props.validator(value);
      }
      //返回字符串 不为空表示校验没通过 且返回错误提示
      if (!(0, _data.isEmptyString)(explain)) {
        flag = false;
      } else {
        explain = '';
      }
    }
    _this5.state.explain = explain;
    _this5.state.valid = flag;
    _this5.forceUpdate();
    return flag;
  };

  this.doValidate = function (type, rules) {
    if (!_this5.props.combobox) {
      return;
    }
    var valid = true,
        rule,
        value = (0, _util3.getShowValue)(_this5.state.value).value,
        explain = "";
    for (var i = 0; i < rules.length; i += 1) {
      rule = rules[i];
      // required不为空  whitespace不全为空串  pattern正则表达式  validator 校验不通过提示message
      for (var prop in rule) {
        //必填项校验
        if (prop === "required" && rule[prop]) {
          if ((0, _data.isEmptyString)(value)) {
            valid = false;
            explain = rule['message'];
            break;
          }
        }
        //全为空校验
        if (prop === "whitespace" && rule[prop]) {
          if (value.trim() === "") {
            valid = false;
            explain = rule['message'];
            break;
          }
        }
        //正则校验
        if (prop === "pattern") {
          var pattern = (0, _data.getPattern)(rule[prop]);
          if (pattern && !pattern.test(value)) {
            valid = false;
            explain = rule['message'];
            break;
          }
        }
        //最大长度校验
        if (prop === "maxLength") {
          if ((value || "").length > rule[prop]) {
            valid = false;
            explain = rule['message'];
            break;
          }
        }
        //自定义校验
        if (prop === "validator" && (0, _data.isFunction)(rule[prop])) {
          explain = rule[prop](value);
          //返回字符串 不为空表示校验没通过 且返回错误提示
          if (!(0, _data.isEmptyString)(explain)) {
            valid = false;
            break;
          } else {
            explain = "";
          }
        }
      }
      if (!valid) {
        break;
      }
    }
    // onBlur 后如果校验通过  就去记忆最近一次 onChange 后的校验结果
    if (type === "onChange") {
      _this5.rememberExplain = { valid: valid, explain: explain };
    } else if (valid && _this5.rememberExplain) {
      // 如果当前的校验通过了, 记忆之前的校验状态
      explain = _this5.rememberExplain.explain;
      valid = _this5.rememberExplain.valid;
    }
    _this5.setState({ explain: explain, valid: valid });
    return valid;
  };

  this.reset = function () {
    if (_this5.props.mode !== "view") {
      (function () {
        var resetValue = (0, _util3.getRenderValue)(_this5.props.defaultValue, _this5.props) || null;
        _this5._getDefaultAO();
        _this5.clearOption();
        _this5.setState({ value: resetValue, valid: true, explain: "", showData: null, data: [], allSelect: false, searchword: '' }, function () {
          if (_this5._isSelectOptionAtBeginning()) {
            _this5._selectOptionAtBeginningHandler();
          } else {
            _this5.props.onChange(resetValue);
          }
        });
      })();
    }
  };

  this.clear = function () {
    _this5.setState({ valid: true, explain: "" });
  };

  this.clearOption = function () {
    _this5.setState({
      data: [],
      showData: null,
      allSelect: false,
      fetchErrorMessage: ''
    });
  };

  this.fillOptions = function (data, callback) {
    var value = _this5.state.value;

    var showData = (0, _util3.getShowData)(data, _this5.props, value);
    _this5._getDefaultAO();
    _this5.setState({
      data: data,
      showData: showData,
      allSelect: _this5.props.multiple ? _this5._isAllSelect(value, showData) : false
    }, function () {
      _this5.props.align && (_this5.props.align.points || _this5.props.align.overflow) && _this5.refs.trigger.forceAlign();
      callback && callback();
    });
  };

  this.getOptions = function () {
    return _this5.state.showData;
  };

  this.focusInput = function () {
    var input = (0, _reactDom.findDOMNode)(_this5.refs.input);
    input && input.focus ? input.focus() : _this5._focusHandle();
  };

  this.blurInput = function () {
    var input = (0, _reactDom.findDOMNode)(_this5.refs.input);
    input && input.blur && input.blur();
  };

  this.hideDropdown = function () {
    var oldsearch = _this5.state.searchword;
    _this5.searching = false;
    _this5.setState({ visible: false, searchword: '' }, function () {
      _this5.timeout && clearTimeout(_this5.timeout);
      _this5._getDefaultAO();
      oldsearch && _this5.clearOption();
      _this5.validate();
    });
  };
}, _temp);

// 渲染弹出框中的内容
// TODO 文字超长时不折行只省略  并添加 toolTips 来显示全文

var TriggerContent = function (_Component) {
  _inherits(TriggerContent, _Component);

  function TriggerContent(props) {
    _classCallCheck(this, TriggerContent);

    var _this6 = _possibleConstructorReturn(this, Object.getPrototypeOf(TriggerContent).call(this, props));

    _this6.setActiveOption = function (activeOptionIndex) {
      _this6.setState({ activeOptionIndex: activeOptionIndex });
    };

    _this6.getActiveOptionIndex = function () {
      return _this6.state.activeOptionIndex;
    };

    _this6.state = {
      activeOptionIndex: props.defaultActiveFirstOption ? 0 : null
    };
    return _this6;
  }

  _createClass(TriggerContent, [{
    key: 'render',
    value: function render() {
      var _classNames6,
          _this7 = this;

      var props = this.props;
      var parent = props.parent;
      var loading = props.loading;
      var showData = props.showData;
      var value = props.value;
      var allSelect = props.allSelect;
      var prefixCls = props.prefixCls;
      var model = props.model;
      var multiple = props.multiple;
      var combobox = props.combobox;
      var notFoundContent = props.notFoundContent;
      var maxLength = props.maxLength;
      var size = props.size;
      var ellipsis = props.ellipsis;
      var activeOptionIndex = this.state.activeOptionIndex;
      var disabledField = model.disabledField;

      prefixCls = prefixCls + '-select' + (multiple ? '-multiple' : '');

      var hasData = (showData || []).length > 0;
      if (!hasData && combobox) {
        // 如果没有数据  联想模式不显示下拉框
        return null;
      }

      var outerCls = (0, _classnames2.default)((_classNames6 = {}, _defineProperty(_classNames6, prefixCls + '-dropdown', true), _defineProperty(_classNames6, prefixCls + '-dropdown-sm', size === 'small'), _classNames6));

      if (loading) {
        // 加载中
        return _react2.default.createElement(
          'div',
          { className: outerCls, style: { maxHeight: model.height || 'auto' } },
          _react2.default.createElement(
            'ul',
            { className: prefixCls + '-list' },
            _react2.default.createElement(
              'li',
              { className: prefixCls + '-loading' },
              _react2.default.createElement('i', { className: _data.IconPrefixCls + ' ' + _data.IconPrefixCls + '-loading' })
            )
          )
        );
      }
      if (multiple && (value || []).length + 1 > maxLength) {
        // 超过最大可选条数
        return _react2.default.createElement(
          'div',
          { className: outerCls, style: { maxHeight: model.height || 'auto' } },
          _react2.default.createElement(
            'ul',
            { className: prefixCls + '-list' },
            _react2.default.createElement(
              'li',
              { className: prefixCls + '-outLength', onClick: parent.hideDropdown },
              '您最多只能选择',
              maxLength,
              '条'
            )
          )
        );
      }
      if (!hasData) {
        // 没有数据
        return _react2.default.createElement(
          'div',
          { className: outerCls, style: { maxHeight: model.height || 'auto' } },
          _react2.default.createElement(
            'ul',
            { className: prefixCls + '-list' },
            _react2.default.createElement(
              'li',
              { className: prefixCls + '-notfound', onClick: parent.hideDropdown },
              notFoundContent
            )
          )
        );
      }
      return _react2.default.createElement(
        'div',
        { className: outerCls, ref: 'container', style: { maxHeight: model.height || 'auto' } },
        (0, _util3.isAllSelectShow)(props) && _react2.default.createElement(
          'div',
          { className: prefixCls + '-allCheck',
            onClick: parent._allSelectHandle.bind(this, allSelect) },
          _react2.default.createElement(_checkbox.Checkbox, { size: size, checked: allSelect }),
          _react2.default.createElement(
            'span',
            null,
            '全选'
          )
        ),
        _react2.default.createElement(
          'ul',
          { className: prefixCls + '-list' },
          (showData || []).map(function (v, k) {
            var isMultipleOptionActive = multiple && (value || []).some(function (item) {
              return item.value === v.value;
            });
            // FIXME ellipsis 超长是否省略显示
            var liCls = (0, _classnames2.default)(_defineProperty({
              'active': value && (multiple ? allSelect || isMultipleOptionActive : value.value === v.value),
              'focus': activeOptionIndex === k,
              'disabled': v[disabledField]
            }, prefixCls + '-ellipsis', ellipsis));
            var showLabel = "";
            if (model.format) {
              showLabel = (0, _data.getComponent)(model.format, _extends({}, v, { index: k }));
            } else {
              var _showLabel = model.tpl ? _util2.default.template(model.tpl, v) : v[model.showField];
              showLabel = _react2.default.createElement(
                'div',
                { title: _showLabel },
                _showLabel
              );
            }
            return _react2.default.createElement(
              'li',
              { key: k,
                onClick: v[disabledField] ? function () {} : parent[multiple ? '_multiSelectHandle' : '_selectHandle'].bind(null, k, null),
                className: liCls,
                onMouseEnter: v[disabledField] ? function () {} : _this7.setActiveOption.bind(_this7, k),
                ref: 'option_' + k },
              (0, _util3.isCheckboxShow)(props) ? _react2.default.createElement(
                _checkbox.Checkbox,
                { prefixCls: prefixCls,
                  size: size,
                  disabled: v[disabledField],
                  checked: !!isMultipleOptionActive },
                showLabel
              ) : showLabel
            );
          })
        )
      );
    }
  }]);

  return TriggerContent;
}(_react.Component);

Select.TriggerContent = TriggerContent;

exports.default = Select;